import React, { Component } from "react";
import { NavLink as RRNavLink } from "react-router-dom";
import styled from "styled-components";
import { getTaskCount, getSetup } from "./../../Constants/Services";
import { NavItem, Navbar, Nav, NavLink, Row, Col, Container, Label } from "reactstrap";
import StoreContext from "./../../../Store/Context";
import { ISetup } from "./../../Constants/Interfaces";
import { LOGO_SCHOOL, LOGOUT_ICON, AGENDA_ICON, NOTAS_ICON, HORARIO_ICON, HOME_ICON, PAYMENT_ICON,HOMEWORK_ICON } from "../../Constants/SrcImages";
import { push as Menu } from "react-burger-menu";
import {GET_WEEK_START_END} from "./../../Constants/Util"
import "./../../../www/css/Menu.css";
import moment from "moment";
const Logo = styled.img`
  height: 100px;
  width: 100px;
  margin: auto;
`;

var styles = {
  bmBurgerButton: {
    position: "fixed",
    width: "36px",
    height: "30px",
    left: "26px",
    top: "16px",
  },
  bmBurgerBars: {
    background: "#373a47",
  },
  bmBurgerBarsHover: {
    background: "#a90000",
  },
  bmCrossButton: {
    height: "24px",
    width: "24px",
  },
  bmCross: {
    background: "#bdc3c7",
  },
  bmMenuWrap: {
    position: "fixed",
    height: "100%",
  },
  bmMenu: {
    background: "#373a47",
    padding: "2.5em 1.5em 0",
    fontSize: "1.15em",
  },
  bmMorphShape: {
    fill: "#373a47",
  },
  bmItemList: {
    color: "#b8b7ad",
    padding: "0.8em",
  },
  bmItem: {
    display: "inline-block",
  },
  bmOverlay: {
    background: "rgba(0, 0, 0, 0.3)",
  },
};

interface ILayoutState {
  menuOpen: boolean;
  children: any;
  dataFormSetup: ISetup;
  count: string;
  count_total: string;
}
interface ILayoutProps {
  children: any;
}
class LayoutParents extends Component<ILayoutProps, ILayoutState> {
  _isMounted = false;
  static contextType = StoreContext;
  constructor(props: ILayoutProps) {
    super(props);
    this.state = {
      menuOpen: false,
      children: props.children,
      dataFormSetup: {
        set_registrationy: "",
        set_aniolectivo: "",
        set_startpactivo: moment(new Date().toString()).format("YYYY-MM-DD HH:mm:ss"),
        set_endpactivo:moment(new Date().toString()).format("YYYY-MM-DD HH:mm:ss"),
        set_start_ft: moment(new Date().toString()).format("YYYY-MM-DD HH:mm:ss"),
        set_end_ft: moment(new Date().toString()).format("YYYY-MM-DD HH:mm:ss"),
        set_start_st: moment(new Date().toString()).format("YYYY-MM-DD HH:mm:ss"),
        set_end_st: moment(new Date().toString()).format("YYYY-MM-DD HH:mm:ss"),
        set_start_tt: moment(new Date().toString()).format("YYYY-MM-DD HH:mm:ss"),
        set_end_tt: moment(new Date().toString()).format("YYYY-MM-DD HH:mm:ss"),
        set_trimestre: "",
      },
      count: "0",
      count_total: "0",
    };
    this.fetchTaskCount = this.fetchTaskCount.bind(this);
  }

  handleStateChange(state: any) {
    this.setState({ menuOpen: state.isOpen });
  }

  closeMenu() {
    this.setState({ menuOpen: false });
  }

  toggleMenu() {
    this.setState((prevState) => ({
      menuOpen: !prevState.menuOpen,
    }));
  }

  updateTokens = () => {
    const test = this.context;
    test.quitToken();
  };

  async fetchTaskCount({ trimestre,dataFormSetup }) {
    var dataStartTrimestre;
    var dataEndTrimestre;

    if (trimestre === "I") {
      dataStartTrimestre = dataFormSetup.set_start_ft;
      dataEndTrimestre = dataFormSetup.set_end_ft;
    } else if (trimestre === "II") {
      dataStartTrimestre = dataFormSetup.set_start_st;
      dataEndTrimestre = dataFormSetup.set_end_st;
    } else if (trimestre === "III") {
      dataStartTrimestre = dataFormSetup.set_start_tt;
      dataEndTrimestre = dataFormSetup.set_end_tt;
    }

    var daysMonth = GET_WEEK_START_END({
      startDate: dataStartTrimestre,
      endDate: dataEndTrimestre,
    });

    var position = 0;
    var position2 =0;
    daysMonth.map((data, i) => {
      if( moment(new Date()).isAfter(moment(data.dateStart).format("YYYY-MM-DD")) &&   moment(new Date()).isBefore(moment(data.dateEnd).add(1,'days').format("YYYY-MM-DD")))
      {
       position=i;
      }
      return null
    });

    var fechaFiltro;
      if (
        moment(moment(new Date()).format("YYYY-MM-DD HH:mm:ss")).isAfter(moment(daysMonth[position.toString()].dateEnd)
        .subtract(2, "days").add(14, "hours").format("YYYY-MM-DD HH:mm:ss"))
      ){
        position2 = position +1;
        fechaFiltro = moment(daysMonth[position2.toString()].dateEnd).format("YYYY-MM-DD");
      }
      else{
        fechaFiltro = moment(daysMonth[position.toString()].dateEnd).format("YYYY-MM-DD");
      }

   const response = await getTaskCount({
    per_id: this.context.per_std,
    date_week_start: moment(dataStartTrimestre).format("YYYY-MM-DD"),
    date_week_end: fechaFiltro,
  });

    if (this._isMounted) {
      this.setState({ count: response.count});
    }
   
  }

  async fetchSetup() {
    const response = await getSetup();
    setTimeout(() => {
      this.fetchTaskCount({ trimestre: response.set_trimestre, dataFormSetup: response });
    }, 500);
  }

  componentDidMount() {
    this._isMounted = true;
      this.fetchSetup();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {window.screen.width < 576 && (
          <div className="d-block d-sm-none">
            {/* MOBILE */}
            <Menu id="menu-mb" styles={styles} width={180} isOpen={this.state.menuOpen} onStateChange={(state) => this.handleStateChange(state)}>
              <img className="logo-mobile" src={LOGO_SCHOOL} alt="" />
              <NavItem className="text-center w-100 mt-5 d-flex">
                <img src={HOME_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/parents/home" onClick={() => this.closeMenu()}>
                  Inicio
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={AGENDA_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/parents/agenda" onClick={() => this.closeMenu()}>
                  Agenda
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={NOTAS_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/parents/notes" onClick={() => this.closeMenu()}>
                  Notas
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={HORARIO_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/parents/schedule" onClick={() => this.closeMenu()}>
                  Horario
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={PAYMENT_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/parents/payment" onClick={() => this.closeMenu()}>
                  Pagos
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex" onClick={() => this.updateTokens()}>
                <img src={LOGOUT_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/parents/profile">
                  Salir
                </NavLink>
              </NavItem>
              <Label className="task-label">
              Tareas y revisiones Faltantes: {props.count}
              </Label>
              <img src={HOMEWORK_ICON} alt="" className="homework-icon"/>
            </Menu>
            <Container className="font-size-14">
              <Row>
                <Col sm={12} className="container-mobile">
                  {this.props.children}
                </Col>
              </Row>
            </Container>
          </div>
        )}

        {window.screen.width > 576 && (
          <div className="d-none d-sm-block">
            <Container fluid={true} className="font-size-14">
              <Row>
                <Col sm={2}>
                  <Row>
                    <Navbar>
                      <Nav tabs>
                        <NavItem className="text-center w-100">
                          <Logo src={LOGO_SCHOOL} alt="" />
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink tag={RRNavLink} to="/parents/home" activeClassName="active">
                            Inicio
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink tag={RRNavLink} to="/parents/agenda" activeClassName="active">
                            Agenda
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink tag={RRNavLink} to="/parents/notes" activeClassName="active">
                            Notas
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink tag={RRNavLink} to="/parents/schedule" activeClassName="active">
                            Horario
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink tag={RRNavLink} to="/parents/payment" activeClassName="active">
                            Pagos
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100" onClick={() => this.updateTokens()}>
                          <NavLink tag={RRNavLink} to="/parents/profile">
                            Salir
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Navbar>
                  </Row>
                  <Row>
                    <Col xs={2}>
                    </Col>
                    <Col xs={10} className="text-center">
                      <Label className="font-weight-bold">
                      Tareas y revisiones Faltantes: {props.count}
                      </Label>
                      <img src={HOMEWORK_ICON} alt="" className="homework-icon"/>
                      </Col>

                  </Row>
                </Col>
                <Col className="mt-50px" sm={10}>
                  {this.props.children}
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default LayoutParents;